import { Http } from '../../../support';

export const initialState = {
  busy: false,
  data: {
    catalogo: 'carta-porte-autocompletado',
  },
  progress: 0,
  result: undefined,
  error: undefined,
};

const reset = (store, data) => {
  store.setState((state) => {
    state.modulo.catalogo.cliente.upload = { ...initialState };
  });
};

const onChange = (store, data) => {
  store.setState((state) => {
    state.modulo.catalogo.cliente.upload.data = {
      ...state.modulo.catalogo.cliente.upload.data,
      ...data,
    };
  });
};

const progress = (store, progress) => {
  store.setState((state) => {
    state.modulo.catalogo.cliente.upload.progress = progress;
  });
};

const upload = async (store, onUploadProgress = () => {}) => {
  store.setState((state) => {
    state.modulo.catalogo.cliente.upload.busy = true;
  });

  try {
    const options = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress,
    };

    const { upload } = store.state.catalogoCliente;

    let formData = new FormData();

    formData.append('file', upload.data.file);
    formData.append('catalogo', upload.data.catalogo);

    const response = await Http.post(`${window.BONJOUR_URL}/api/catalogos/cliente/carta-porte`, formData, options);

    store.setState((state) => {
      state.modulo.catalogo.cliente.upload.progress = 100;
      state.modulo.catalogo.cliente.upload.busy = false;
      state.modulo.catalogo.cliente.upload.result = response;
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.catalogo.cliente.upload.busy = false;
      state.modulo.catalogo.cliente.upload.error = error.data || error;
    });
  }
};

const CatalogoClienteUploadStore = {
  state: () => initialState,
  actions: {
    reset,
    onChange,
    progress,
    upload,
  },
};

export default CatalogoClienteUploadStore;
